@if ((loading$ | async) === false) {
  @if ((canAcceptPayment$ | async) === true) {
    <div *ngIf="retailBalance$ | async as currentBalances" class="card-container-layout">
      <ng-container *ngIf="payoutSchedule$ | async as payoutSchedule">
        <mat-card appearance="outlined" class="left-card-layout">
          <mat-card-header>
            <mat-card-title class="card-header">
              {{ 'PAYOUTS_PAGE.CURRENT_BALANCE.TITLE' | translate }}
              <mat-icon inline matTooltip="{{ 'PAYOUTS_PAGE.CURRENT_BALANCE.TOOLTIP' | translate }}"> info </mat-icon>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <div *ngFor="let balance of currentBalances.balances" class="amount">
              {{ balance.futurePayouts / 100 | glxyCurrency: balance.currencyCode }}
            </div>
            @if ((redirectToStripe$ | async) === false) {
              <div>
                {{ payoutSchedule }}
              </div>
            }
          </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="right-card-layout">
          <mat-card-header>
            <mat-card-title class="card-header">
              {{ 'PAYOUTS_PAGE.IN_TRANSIT.TITLE' | translate }}
              <mat-icon inline matTooltip="{{ 'PAYOUTS_PAGE.IN_TRANSIT.TOOLTIP' | translate }}"> info </mat-icon>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <div *ngFor="let balance of currentBalances.balances" class="amount">
              {{ balance.inTransit / 100 | glxyCurrency: balance.currencyCode }}
            </div>
            <div *ngIf="currentBalances.nextInTransitPayout">
              {{ 'PAYOUTS_PAGE.IN_TRANSIT.NEXT_PAYOUT' | translate }}
              {{ currentBalances.nextInTransitPayout | glxyDate: DateFormat.longDate }}
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>

    <div class="payout-list-layout">
      <smb-invoicing-payout-list
        [shouldShowPayouts]="(redirectToStripe$ | async) === false"
        [merchantId$]="merchantId$"
        (payoutSelected)="onPayoutSelected($event)"
      ></smb-invoicing-payout-list>
    </div>
  } @else {
    @if ((redirectToStripe$ | async) === false) {
      <smb-invoicing-retail-payments-onboarding
        [isSupportedRegion]="supportedRegion$ | async"
        description="PAYMENTS_ONBOARDING.CTA.DESCRIPTION.PAYOUTS_PAGE"
        (onboardingUnsupportedRegionClicked)="onboardingUnsupportedRegionClicked($event)"
        (onboardingCallToActionClicked)="onboardingCallToActionClicked($event)"
      ></smb-invoicing-retail-payments-onboarding>
    }
  }
}
